// @flow
// $FlowFixMe
import React, { useRef } from 'react';
import CapacitorRipple from '../capacitor/Ripple';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import styles from './PriceInfoTooltip.css';

declare var __CAPACITOR__: boolean;

type OwnProps = {
  intl: IntlShape,
};

const messages = defineMessages({
  priceInfo: {
    id: 'livestream-events.price-info-tooltip.icon',
    defaultMessage: 'Price Info',
  },
});

const PriceInfoIcon = () => {
  return (
    <svg>
      <use xlinkHref="#icon-info-italic" />
    </svg>
  );
};

const PriceInfoTooltip = ({ intl }: OwnProps) => {
  const id = 'price-info';
  const ref = useRef(null);
  const timeoutRef = useRef(null);

  const handleTriggerClick = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (__CAPACITOR__) {
      // For some reason, after we auto-hide the plugin, we need to manually
      // call the show method to actually show the tooltip again.
      ReactTooltip.show(ref.current);

      timeoutRef.current = setTimeout(() => {
        ReactTooltip.hide(ref.current);
      }, 5000);
    }
  };

  return (
    <span>
      <button
        className={styles.main}
        data-tip
        data-for={id}
        ref={ref}
        onClick={handleTriggerClick}
        aria-label={intl.formatMessage(messages.priceInfo)}
      >
        <CapacitorRipple />
        <PriceInfoIcon />
      </button>
      <ReactTooltip className={styles.tooltip} id={id} effect="solid">
        <FormattedMessage
          id="livestream-events.price-info-tooltip.text"
          defaultMessage="This event is pay-as-you-wish: you can choose to pay any price within the given price range."
        />
      </ReactTooltip>
    </span>
  );
};

export default injectIntl(PriceInfoTooltip);
